import React from 'react';
import { Router } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import routes from '../routes';
import { initializeGA } from '../utils/googleAnalytics';
import { dataLayerGTM } from '../utils/googleTagManager';

const propTypes = {
  store: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
  debug: PropTypes.bool,
  userId: PropTypes.string,
};

const defaultProps = {
  history: {},
  store: {},
  debug: false,
  userId: null,
};

class InitializeAnalytics extends React.Component {
  componentWillReceiveProps() {
    const userId = this.props.userId;
    initializeGA({ debug: this.props.debug, gaOptions: { userId } });
    dataLayerGTM({ uid: userId });
  }

  render() {
    return (
      <Router history={this.props.history}>
        {routes(this.props.store)}
      </Router>
    );
  }
}

InitializeAnalytics.propTypes = propTypes;
InitializeAnalytics.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
  };
};

export default connect(mapStateToProps)(InitializeAnalytics);
